import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function StrategicAccessInquiry() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="strategic-access-inquiry" className="dark bg-background text-foreground relative overflow-hidden py-32 md:py-48 flex flex-col items-center justify-center text-center">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[radial-gradient(circle,var(--color-secondary)_0%,transparent_70%)] opacity-20 blur-3xl" />
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" />
      </div>

      <div ref={ref} className={cn("relative z-10 container mx-auto px-4 transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="font-serif text-4xl md:text-[64px] leading-[1.1] tracking-tight mb-12 max-w-5xl mx-auto text-foreground">
          Ready to Structure Capital for Your Next Move?
        </h2>

        <div className="flex justify-center">
          <Link to="/ContactPage">
            <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-lg px-12 h-16 rounded-sm font-medium tracking-wide shadow-[0_0_20px_-5px_rgba(255,255,255,0.3)] transition-all duration-300 hover:scale-[1.02]">
              Submit Funding Request
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}